import { useState } from "react";
import styles from "./SearchBooking.module.css";
import BookingHistory from "../BookingHistory/BookingHistory";
import { REQUEST_FAILED, SEARCH_COMPLETED } from "../Common/Constant";
import MyAxios from "../axios/CustomAxios";

const SearchBooking = () => {
  // Sample data for demonstration

  const [searchResult, setSearchResult] = useState(null);
  const [searchStatus, setSearchStatus] = useState("");
  const [bookingId, setBookingId] = useState("");

  const onSearchClick = () => {
    setSearchStatus("");
    try {
      MyAxios.get(`/booking/search-by-bookingId`, {
        params: { bookingId },
      })
        .then((res) => {
          if (res.data) {
            setSearchResult(res.data);
          } else {
            setSearchResult(null);
          }
          setSearchStatus(SEARCH_COMPLETED);
        })
        .catch((err) => {
          console.error(err);
          setSearchResult(null);
          setSearchStatus(err?.response?.data?.error || REQUEST_FAILED);
        });
    } catch (err) {
      console.error(err);
      localStorage.removeItem("token");
      window?.location?.reload && window.location.reload();
    }
  };

  const onSearchInputChange = (e) => {
    setBookingId(e?.target?.value);
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.searchBoxDiv}>
          <input
            id="bookingIdInput"
            type="text"
            className={styles.inputBox}
            placeholder="Booking Id"
            onChange={onSearchInputChange}
            autoFocus={true}
            autoComplete="off"
          />
          <button
            className={styles.searchBtn}
            disabled={!bookingId}
            onClick={onSearchClick}
          >
            Search
          </button>
        </div>
      </div>
      {searchStatus != "" && (
        <BookingHistory
          isSearchList
          searchResult={searchResult}
          searchStatus={searchStatus}
        />
      )}
    </>
  );
};

export default SearchBooking;
